export const surgeryConst = {
  path: "/single-programs/surgery",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ХИРУРГИЯ (по направлениям)",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Хирургия — мастерство спасения жизни</h2>
      <p>
        Хирургия — это одна из ключевых дисциплин современной медицины, направленная на лечение болезней и травм с помощью оперативных
        вмешательств. Программа охватывает широкий спектр хирургических направлений, включая:
      </p>
      <ul>
        <li>Общую хирургию</li>
        <li>Абдоминальную хирургию</li>
        <li>Сосудистую хирургию</li>
        <li>Торакальную хирургию</li>
        <li>Онкохирургию</li>
        <li>Пластическую и реконструктивную хирургию</li>
        <li>Ургентную и неотложную помощь</li>
      </ul>
      <p>
        Студенты получают комплексную подготовку как в теоретических аспектах, так и в практических навыках — от анатомии до современных
        высокотехнологичных методов операций.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы и техника хирургических вмешательств</li>
        <li>Анестезиология и интенсивная терапия</li>
        <li>Послеоперационное ведение и реабилитация</li>
        <li>Современные технологии: лапароскопия, роботизированная хирургия</li>
        <li>Инфекционные и асептические аспекты</li>
        <li>Клинические случаи и разборы в симуляционных центрах</li>
        <li>Этические и правовые аспекты хирургической практики</li>
      </ul>
      <p>Практика проходит в хирургических отделениях ведущих клиник с доступом к современному оборудованию.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Общий хирург</li>
        <li>Абдоминальный хирург</li>
        <li>Онкохирург</li>
        <li>Травматолог</li>
        <li>Торакальный или сосудистый хирург</li>
        <li>Пластический и реконструктивный хирург</li>
        <li>Хирург неотложной помощи</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Хирурги стабильно входят в ТОП самых востребованных и высокооплачиваемых медицинских специалистов в ЕС.</p>
      <p>
        <strong>Средняя зарплата в Европе: от €70,000 до €140,000 в год,</strong> в зависимости от страны и специализации.
      </p>
      <h2>Почему выбирают нашу программу?</h2>
      <ul>
        <li>Европейский диплом с возможностью работы в разных странах</li>
        <li>Мощная теоретическая и практическая база</li>
        <li>Обучение в симуляционных центрах и реальных клиниках</li>
        <li>Программа разработана с учетом международных стандартов</li>
        <li>Возможность специализации и научной деятельности</li>
        <li>Индивидуальное сопровождение до и после выпуска</li>
      </ul>
      <h2>Хирургия — это точность, ответственность и результат</h2>
      <p>Программа создана для тех, кто готов принять вызов и стать мастером своего дела — в операционной и за её пределами.</p>
      <br />
      <p className="padding-left">«Каждая операция — это шанс спасти жизнь и изменить судьбу.»</p>
      <h2>Как поступить?</h2>
      <p>Узнайте подробнее о программе, стоимости и документах — отправьте заявку прямо сейчас.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Хирургия — мастерство спасения жизни
    Хирургия — это одна из ключевых дисциплин современной медицины, направленная на лечение болезней и травм с помощью оперативных вмешательств. Программа охватывает широкий спектр хирургических направлений, включая:
    Общую хирургию
    Абдоминальную хирургию
    Сосудистую хирургию
    Торакальную хирургию
    Онкохирургию
    Пластическую и реконструктивную хирургию
    Ургентную и неотложную помощь
    Студенты получают комплексную подготовку как в теоретических аспектах, так и в практических навыках — от анатомии до современных высокотехнологичных методов операций.


    Что вы будете изучать?
    • Основы и техника хирургических вмешательств
    • Анестезиология и интенсивная терапия
    • Послеоперационное ведение и реабилитация
    • Современные технологии: лапароскопия, роботизированная хирургия
    • Инфекционные и асептические аспекты
    • Клинические случаи и разборы в симуляционных центрах
    • Этические и правовые аспекты хирургической практики
    Практика проходит в хирургических отделениях ведущих клиник с доступом к современному оборудованию.

    Кем можно работать после окончания?
    • Общий хирург
    • Абдоминальный хирург
    • Онкохирург
    • Травматолог
    • Торакальный или сосудистый хирург
    • Пластический и реконструктивный хирург
    • Хирург неотложной помощи

    Востребованность и доход
    Хирурги стабильно входят в ТОП самых востребованных и высокооплачиваемых медицинских специалистов в ЕС.
    Средняя зарплата в Европе: от €70,000 до €140,000 в год, в зависимости от страны и специализации.

    Почему выбирают нашу программу?
    • Европейский диплом с возможностью работы в разных странах
    • Мощная теоретическая и практическая база
    • Обучение в симуляционных центрах и реальных клиниках
    • Программа разработана с учетом международных стандартов
    • Возможность специализации и научной деятельности
    • Индивидуальное сопровождение до и после выпуска

    Хирургия — это точность, ответственность и результат
    Программа создана для тех, кто готов принять вызов и стать мастером своего дела — в операционной и за её пределами.
    «Каждая операция — это шанс спасти жизнь и изменить судьбу.»

    Как поступить?
    Узнайте подробнее о программе, стоимости и документах — отправьте заявку прямо сейчас.
  `,
};
